var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = ["open"];
var _hoisted_2 = { class: "more-box__title" };
var _hoisted_3 = { class: "more-box__marker" };
var _hoisted_4 = { class: "more-box__main" };
var _hoisted_5 = { class: "filt-box" };
var _hoisted_6 = {
    key: 0,
    class: "filt-box__bottom"
};
var _hoisted_7 = { class: "line line--jcfe" };
var _hoisted_8 = { class: "line__item" };
var _hoisted_9 = ["disabled"];
import Sprite from "../../../components/Sprite.vue";
import { ref, watch } from "vue";
import { useFilterStore } from "../store";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ItemWrapper',
    props: {
        item: { type: Object, required: true },
        noResetButton: { type: Boolean, default: false },
    },
    emits: ['reset'],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var store = useFilterStore();
        var props = __props;
        var emit = __emit;
        var expanded = ref(props.item.expanded);
        watch(function () { return props.item.expanded; }, function (value) {
            expanded.value = value;
        });
        function toggle() {
            expanded.value = props.item.expanded = !expanded.value;
            store.saveExpandedStateToSession();
        }
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("details", {
                class: "more-box more-box--bg",
                open: expanded.value
            }, [
                _createElementVNode("summary", {
                    class: "more-box__top",
                    onClick: _withModifiers(toggle, ["prevent"])
                }, [
                    _createElementVNode("span", _hoisted_2, [
                        _createTextVNode(_toDisplayString(__props.item.title) + " ", 1 /* TEXT */),
                        _renderSlot(_ctx.$slots, "badge")
                    ]),
                    _cache[1] || (_cache[1] = _createTextVNode()),
                    _createElementVNode("span", _hoisted_3, [
                        _createVNode(Sprite, { name: "arrow-down" })
                    ])
                ]),
                _cache[4] || (_cache[4] = _createTextVNode()),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _renderSlot(_ctx.$slots, "body"),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        (__props.item.active && !__props.noResetButton)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn--2 btn--m btn--black",
                                            onClick: _cache[0] || (_cache[0] = _withModifiers(function ($event) { return (_ctx.$emit('reset')); }, ["prevent"])),
                                            disabled: !__props.item.active
                                        }, __spreadArray([], __read((_cache[2] || (_cache[2] = [
                                            _createElementVNode("span", { class: "btn__label" }, "Сбросить выбор", -1 /* CACHED */)
                                        ]))), false), 8 /* PROPS */, _hoisted_9)
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ])
            ], 8 /* PROPS */, _hoisted_1));
        };
    }
});
